import * as React from 'react';

interface IMapLegendProps {
    siteSelect: boolean;
    show?: boolean;
}

class MapLegend extends React.PureComponent<IMapLegendProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        const rows = this.props.siteSelect ? <>
            <tr>
                <th className="text-center">
                    <svg height="25" width="25">
                        <path d="M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z" transform="translate(23,28), scale(-0.7, -0.7)" fill="#444044" />
                    </svg>
                </th>
                <th><strong>Public Site</strong></th>
            </tr>
            <tr>
                <th className="text-center">
                    <svg height="25" width="25">
                        <path d="M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z" transform="translate(23,28), scale(-0.7, -0.7)" fill="#CCC8CC" />
                    </svg>
                </th>
                <th><strong>Private Site</strong></th>
            </tr>
            <tr>
                <th className="text-center">
                    <svg height="25" width="25">
                        <path d="M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z" transform="translate(23,28), scale(-0.7, -0.7)" fill="#9edeff" />
                    </svg>
                </th>
                <th><strong>Proposed Site</strong></th>
            </tr>
        </> : <>
                <tr>
                    <th className="text-center">
                        <svg height="25" width="25">
                            <path d="M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z" transform="translate(23,28), scale(-0.7, -0.7)" fill="#444044" />
                        </svg>
                    </th>
                    <th><strong>High</strong></th>
                </tr>
                <tr>
                    <th className="text-center">
                        <svg height="25" width="25">
                            <path d="M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z" transform="translate(23,28), scale(-0.7, -0.7)" fill="#888488" />
                        </svg>
                    </th>
                    <th><strong>Medium</strong></th>
                </tr>
                <tr>
                    <th className="text-center">
                        <svg height="25" width="25">
                            <path d="M15 3 Q16.5 6.8 25 18 A12.8 12.8 0 1 1 5 18 Q13.5 6.8 15 3z" transform="translate(23,28), scale(-0.7, -0.7)" fill="#CCC8CC" />
                        </svg>
                    </th>
                    <th><strong>Low</strong></th>
                </tr>
            </>;

        const furtherInfo = <div className="small">
            {this.props.siteSelect
                ? <>
                    <p><strong>Public Site:</strong> available for any registered APMN volunteer to monitor</p>
                    <p><strong>Private site:</strong> located on private land and monitored by the landowner</p>
                    <p><strong>Proposed site:</strong> a new site under evaluation</p> </>
                : <>
                    <p><strong>High:</strong> average no. of sightings/scan <span>&#8805;</span> 0.5</p>
                    <p><strong>Medium:</strong> average no. of sightings/scan = 0.1-0.49</p>
                    <p><strong>Low:</strong> {'average no. of sightings/scan < 0.1'}</p>
                </>
            }
        </div>

        return (
            this.props.show ?
                <div className="p-3 w-100 bg-white rounded shadow mt-md-3">
                    <h6><strong>{this.props.siteSelect ? 'Site Status' : 'Platypus Sightings Frequency'}</strong></h6>
                    <table className="table table-sm border-bottom">
                        <tbody>
                            {rows}
                        </tbody>
                    </table>
                    {furtherInfo}
                </div> : null
        );
    }
}

export default MapLegend;